import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const NoMatchingResults = ({ text }) => {
  return <h5 className="uni-select__message-none">{text}</h5>;
};

NoMatchingResults.propTypes = {
  text: PropTypes.string,
};

export default NoMatchingResults;



// WEBPACK FOOTER //
// ./src/selects/__partials/no-matching-results/index.jsx